import axios from 'axios';

function handle401(error: unknown) {
  const err = error as { response?: { status?: number }; config?: { url?: string } };
  if (err.response?.status === 401) {
    const url = err.config?.url || '';
    const isPublicRoute = url.includes('/verify-password') ||
      url.includes('/save-result') ||
      url.includes('/leaderboard');
    if (!isPublicRoute) {
      window.dispatchEvent(new Event('auth:logout'));
    }
  }
  return Promise.reject(error);
}

axios.interceptors.response.use((r) => r, handle401);

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use((r) => r, handle401);

export default api;
